/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geo_Label_Eastern_AfricaInputs */

const bn_geo_label_eastern_africa = /** @type {(inputs: Geo_Label_Eastern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পূর্ব আফ্রিকা`)
};

const de_geo_label_eastern_africa = /** @type {(inputs: Geo_Label_Eastern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostafrika`)
};

const el_geo_label_eastern_africa = /** @type {(inputs: Geo_Label_Eastern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ανατολική Αφρική`)
};

const en_geo_label_eastern_africa = /** @type {(inputs: Geo_Label_Eastern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eastern Africa`)
};

const es_geo_label_eastern_africa = /** @type {(inputs: Geo_Label_Eastern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`África Oriental`)
};

const fr_geo_label_eastern_africa = /** @type {(inputs: Geo_Label_Eastern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrique de l’Est`)
};

const hi_geo_label_eastern_africa = /** @type {(inputs: Geo_Label_Eastern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्वी अफ़्रीका`)
};

const hu_geo_label_eastern_africa = /** @type {(inputs: Geo_Label_Eastern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelet-Afrika`)
};

const id_geo_label_eastern_africa = /** @type {(inputs: Geo_Label_Eastern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrika Timur`)
};

const it_geo_label_eastern_africa = /** @type {(inputs: Geo_Label_Eastern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Africa orientale`)
};

const ja_geo_label_eastern_africa = /** @type {(inputs: Geo_Label_Eastern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`東アフリカ`)
};

const ko_geo_label_eastern_africa = /** @type {(inputs: Geo_Label_Eastern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`동부 아프리카`)
};

const nl_geo_label_eastern_africa = /** @type {(inputs: Geo_Label_Eastern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oost-Afrika`)
};

const pl_geo_label_eastern_africa = /** @type {(inputs: Geo_Label_Eastern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afryka Wschodnia`)
};

const pt_geo_label_eastern_africa = /** @type {(inputs: Geo_Label_Eastern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`África Oriental`)
};

const ru_geo_label_eastern_africa = /** @type {(inputs: Geo_Label_Eastern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Восточная Африка`)
};

const sv_geo_label_eastern_africa = /** @type {(inputs: Geo_Label_Eastern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Östra Afrika`)
};

const tr_geo_label_eastern_africa = /** @type {(inputs: Geo_Label_Eastern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doğu Afrika`)
};

const uk_geo_label_eastern_africa = /** @type {(inputs: Geo_Label_Eastern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Східна Африка`)
};

const vi_geo_label_eastern_africa = /** @type {(inputs: Geo_Label_Eastern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đông Phi`)
};

const zh_geo_label_eastern_africa = /** @type {(inputs: Geo_Label_Eastern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`东非`)
};

const zh_hant_geo_label_eastern_africa = /** @type {(inputs: Geo_Label_Eastern_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`東非`)
};

/**
* | output |
* | --- |
* | "Eastern Africa" |
*
* @param {Geo_Label_Eastern_AfricaInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const geo_label_eastern_africa = /** @type {((inputs?: Geo_Label_Eastern_AfricaInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geo_Label_Eastern_AfricaInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_geo_label_eastern_africa(inputs)
	if (locale === "de") return de_geo_label_eastern_africa(inputs)
	if (locale === "el") return el_geo_label_eastern_africa(inputs)
	if (locale === "en") return en_geo_label_eastern_africa(inputs)
	if (locale === "es") return es_geo_label_eastern_africa(inputs)
	if (locale === "fr") return fr_geo_label_eastern_africa(inputs)
	if (locale === "hi") return hi_geo_label_eastern_africa(inputs)
	if (locale === "hu") return hu_geo_label_eastern_africa(inputs)
	if (locale === "id") return id_geo_label_eastern_africa(inputs)
	if (locale === "it") return it_geo_label_eastern_africa(inputs)
	if (locale === "ja") return ja_geo_label_eastern_africa(inputs)
	if (locale === "ko") return ko_geo_label_eastern_africa(inputs)
	if (locale === "nl") return nl_geo_label_eastern_africa(inputs)
	if (locale === "pl") return pl_geo_label_eastern_africa(inputs)
	if (locale === "pt") return pt_geo_label_eastern_africa(inputs)
	if (locale === "ru") return ru_geo_label_eastern_africa(inputs)
	if (locale === "sv") return sv_geo_label_eastern_africa(inputs)
	if (locale === "tr") return tr_geo_label_eastern_africa(inputs)
	if (locale === "uk") return uk_geo_label_eastern_africa(inputs)
	if (locale === "vi") return vi_geo_label_eastern_africa(inputs)
	if (locale === "zh") return zh_geo_label_eastern_africa(inputs)
	return zh_hant_geo_label_eastern_africa(inputs)
});